import { useRef } from 'react'
import type { AriaDialogProps } from 'react-aria'
import { useDialog } from 'react-aria'
import styled from 'styled-components'

const Dialog = styled.div`
  padding: 15px 35px;
  > h3 {
    margin-top: 0;
  }
`

interface DialogProps extends AriaDialogProps {
  title?: React.ReactNode
  children: React.ReactNode
}

export function RADialog({ title, children, ...props }: DialogProps) {
  const ref = useRef(null)
  const { dialogProps, titleProps } = useDialog(props, ref)

  return (
    <Dialog {...dialogProps} ref={ref}>
      {title && <h3 {...titleProps}>{title}</h3>}
      {children}
    </Dialog>
  )
}
